module.exports = __webpack_public_path__ + "img/pants_length.784ad972.png";